import { useState }                   from 'react';
import { loadStripe }                 from '@stripe/stripe-js';
import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { useNavigate }                from 'react-router-dom';
import { IoClose }                    from 'react-icons/io5';
import { doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db }                         from '../firebase-config';
import { PLANS }                      from './pages/Pricing';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

/*────────────────────────── checkout form ─────────────────────────*/
const CheckoutForm = ({ close, priceId, planKey, user }) => {
  const stripe   = useStripe();
  const elements = useElements();
  const nav      = useNavigate();

  const [error,   setError]   = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setLoading(true);
    const { error: pmError, paymentMethod } =
      await stripe.createPaymentMethod({ type: 'card', card: elements.getElement(CardElement) });

    if (pmError) {
      setError(pmError.message);
      setLoading(false);
      return;
    }

    // 1) create subscription on our server
    const res = await fetch('http://localhost:4242/create-subscription', {
      method : 'POST',
      headers: { 'Content-Type': 'application/json' },
      body   : JSON.stringify({
        uid             : user.uid,
        email           : user.email,
        priceId,
        paymentMethodId : paymentMethod.id
      })
    });

    if (!res.ok) {
      setError('Subscription request failed');
      setLoading(false);
      return;
    }

    const { clientSecret, subscriptionId } = await res.json();

    // 2) confirm payment
    const { error: confirmError, paymentIntent } =
      await stripe.confirmCardPayment(clientSecret);

    if (confirmError) {
      setError(confirmError.message);
      setLoading(false);
      return;
    }

    // 3) persist credits → Firestore
    const plan = PLANS[planKey];
    const isMonthly = priceId === plan.monthlyPriceId;
    const credits = isMonthly ? plan.monthlyCredits : plan.yearlyCredits;

    await updateDoc(doc(db, 'users', user.uid), {
      accountType     : plan.title,
      currentCredits  : credits,
      subscriptionId,
      lastCreditReset : serverTimestamp()
    });

    nav('/confirmation');
  };

  return (
    <form onSubmit={handleSubmit} className="checkout-form">
      <CardElement className="card-element"/>
      <button type="submit" disabled={!stripe || loading}>
        {loading ? 'Processing…' : 'Pay'}
      </button>
      {error && <p className="error-msg">{error}</p>}
    </form>
  );
};

/*────────────────────────── modal shell ─────────────────────────*/
const PaymentModal = ({ close, priceId, planKey, user }) => (
  <div onClick={close} className="settings-modal-parent">
    <div onClick={e => e.stopPropagation()} className="settings-modal">
      <button onClick={close} className="close-btn"><IoClose/></button>
      <h2 className="modal-heading">Payment</h2>
      <Elements stripe={stripePromise}>
        <CheckoutForm {...{ close, priceId, planKey, user }}/>
      </Elements>
    </div>
  </div>
);

export default PaymentModal;